import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    const cards = this.listTarget.querySelectorAll(".channel-card")

    cards.forEach(card => {
      const name = card.dataset.channelName || ""
      if (query === "" || name.toLowerCase().includes(query)) {
        card.style.display = ""
      } else {
        card.style.display = "none"
      }
    })
  }
}
